export default __webpack_public_path__ + "static/og-image-6cdb3c6c379c9bd74be7dcd99481b706.png";